import { BenchmarkItem, BenchmarkType } from '../types';

export function isFund(item: BenchmarkItem): boolean {
    return item.content_type === BenchmarkType.Fund;
}

export function isFundGroup(item: BenchmarkItem): boolean {
    return item.content_type === BenchmarkType.FundGroup;
}